<template>
    <v-col @click="showVideoDialog" :cols="cols" :md="colsMd" class="exercise-img"
        :class="{ 'exercise-img--clickable': isClickable }" :style="thumbStyle">
        <div v-if="!img" class="exercise-img__fallback">
            <span v-if="initials" class="exercise-img__initials">{{ initials }}</span>
            <v-icon v-else color="txtMuted">mdi-dumbbell</v-icon>
        </div>
        <div v-if="isClickable" class="exercise-img__overlay">
            <v-icon size="20" color="#FFFFFF">mdi-play</v-icon>
        </div>
        <watch-video-dialog v-if="video" :thumb="dialogThumb" :video="video" :is-second-dialog="isSecondDialog"
            :local="localDialog" ref="watchVideo" />
    </v-col>
</template>

<script>
import WatchVideoDialog from "@/components/common/routines/WatchVideoDialog";
import { getInitials } from "@/utils/Common";

export default {
    name: "ExerciseImgVideo",
    components: { WatchVideoDialog },
    props: {
        cols: {
            type: [String, Number],
            default: 2,
        },
        colsMd: {
            type: [String, Number],
            default: 2,
        },
        img: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: ''
        },
        video: {
            type: String,
            default: null
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        localDialog: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        isYoutubeVideo: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        isClickable(vm = this) {
            return !!vm.video && !vm.readonly
        },
        initials(vm = this) {
            return vm.name ? getInitials(vm.name) : ''
        },
        thumbStyle(vm = this) {
            const style = { cursor: vm.isClickable ? 'pointer' : 'default' }
            if (vm.img) {
                style.backgroundImage = `url('${vm.img}')`
                style.backgroundSize = vm.isYoutubeVideo ? 'contain' : 'cover'
            }
            return style
        },
        dialogThumb(vm = this) {
            return vm.img || require(`@/assets/img/brand_mark.png`)
        },
    },
    methods: {
        showVideoDialog() {
            const vm = this
            if (!vm.video || vm.readonly) return
            vm.$refs.watchVideo.show(vm.isYoutubeVideo)
        },
    },
}
</script>

<style scoped>
.exercise-img {
    position: relative;
    overflow: hidden;
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 0 0 4px;
    background-color: var(--v-surface2-base);
}

.exercise-img__fallback {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--v-surface2-base);
}

.exercise-img__initials {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: .5px;
    color: var(--v-txtMuted-base);
}

.exercise-img__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, .4);
    opacity: 0;
    transition: opacity .15s ease;
}

.exercise-img--clickable:hover .exercise-img__overlay {
    opacity: 1;
}
</style>
